import script from "./strike-pending-superseded.vue?vue&type=script&lang=js"
export * from "./strike-pending-superseded.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__